import { Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { EmitService } from '@app/ts/services/emit.service';
import { catchError ,tap} from 'rxjs/operators';
declare var Buffer: any;

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  excludeTokenVerification =[]
  constructor(
    private emitService: EmitService
  ) { 
    // this.excludeTokenVerification= [`${environment.API_END_POINT}/api/v1/auth/authlogin`]
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
        return this.handleApi(request,next);
  }



  handleApiRequest(request, next) {
    const handler = next.handle(request).pipe(
      tap(res=> {
        if (res instanceof HttpResponse) {
               if(res.body.data=='cookie_not_found'){
                this.emitService.subscribeapiError(true);  
               }
                                               
        }
    }),
      catchError((error, caught) => {
        // if ((error.status === 401 || error.status === 403 ) && request.url != environment.API_END_POINT+'auth/authlogin') {
          if ((error.status === 401 || error.status === 403 )) {
          let currentURL = window.location.href
          // window.location.href = environment.LOGIN_URL+encodeURIComponent(this.commonService.encrypt(currentURL))
          // window.location.href=environment.LOGIN_URL;
          // this.store.dispatch(new fromAuth.LogoutAction());
          return throwError(error);
        } else {
          return throwError(error);
        }
      })
    );

    return handler;
  }
  handleApi(request,next) {
    const handler = next.handle(request).pipe(
      tap(res=> {
          if (res instanceof HttpResponse) {  
                 if(res.body.data=='cookie_not_found'){
                  this.emitService.subscribeapiError(true); 
                 }
                                                  
          }
      }));
    return handler;
   }
}
